const requestPopup = document.querySelector('[data-request-popup]');
const requestBtns = document.querySelectorAll('[data-request-btn]');

export function toggleRequestPopup() {
    if (requestPopup.classList.contains('hidden')) {
        requestPopup.classList.remove('hidden');
        requestPopup.classList.add('flex');
    } else {
        requestPopup.classList.remove('flex');
        requestPopup.classList.add('hidden');
    }
}

export default function initRequestForm() {
    if (requestBtns) {
        requestBtns.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                toggleRequestPopup();
            });
        });
    }

    // Open popup when form has errors
    if (requestPopup) {
        const requestFormErrors = requestPopup.querySelectorAll('.text-danger').length;
        if (requestFormErrors > 0) {
            toggleRequestPopup();
        }
    }
}
